import React from 'react';
import EqualizerIcon from '@material-ui/icons/Equalizer';
import { routePaths } from '../../routePaths';
import { translate } from '../../utils';
import { RouteType } from '../../types';
import { BackofficePermission } from '../../generated/graphql';
import Statistics from './Statistics';

const StatisticsRoute: RouteType = {
    exact: false,
    path: routePaths.statistics,
    title: translate('Statistics'),
    icon: EqualizerIcon,
    component: () => <Statistics />,
    permissions: {
        backoffice: [BackofficePermission.HasAccess]
    }
};

export default StatisticsRoute;
